module.exports = __webpack_public_path__ + "img/slider-image-1.6c342bf6.jpg";